import { AreaPage, CardGroup } from '@kanos/web-core';
import { createFileRoute } from '@tanstack/react-router';
import { ConfidentialityTextCard } from '../firm/confidentiality-text-card';
import { DutyAdminOnly } from '../firm/duty-admin-only';
import { DutyTabs } from '../firm/duty-tabs';
import { EmployeesCard } from '../firm/employees-card';
import { TableSearch } from '../table-search';

export const Route = createFileRoute('/obligations/people')({
  // The table keeps its view in the address.
  validateSearch: TableSearch,
  component: People,
});

/** The firm's people with what Kanos holds of them (ADR-083 § 1). */
function People() {
  return (
    <AreaPage title="Pflichten">
      <DutyTabs current="people" />
      <DutyAdminOnly>
        <CardGroup>
          <EmployeesCard />
          <ConfidentialityTextCard />
        </CardGroup>
      </DutyAdminOnly>
    </AreaPage>
  );
}
